import { classNames } from "primereact/utils";

import { pillAlign, positionStyle, resolveGanttLayout } from "./gantt-layout";
import styles from "./gantt.module.scss";
import type { PillMarkProps, PillMarkViewModel } from "./types-gantt";

/** ViewModel do `PillMark`: posição do slot, alinhamento do pill, classes e testids; sem JSX. */
export function useGanttPillMark({
  position,
  tone,
  children,
  lane = 0,
  layout,
  past,
  testId,
  className,
  style,
  classNames: parts,
  ...rest
}: PillMarkProps): PillMarkViewModel {
  const resolved = resolveGanttLayout(layout);

  return {
    slotClassName: classNames(styles.pillSlot, className),
    pillClassName: classNames(styles.pill, parts?.pill),
    contentClassName: parts?.content,
    style: { ...positionStyle(resolved, position, lane), ...style },
    align: pillAlign(position),
    tone,
    dataPast: past || undefined,
    testId,
    slotTestId: testId ? `${testId}-slot` : undefined,
    children,
    rest,
  };
}
